<template>
  <b-card
    no-body
    header-bg-variant="white">
    <div slot="header" class="d-flex flex-wrap align-items-center">
      <div class="mr-5">
        <cool-label>Campaign ID</cool-label>
        <h5>{{ this.cid }}</h5>
      </div>
      <div class="mr-5">
        <cool-label>Creative ID</cool-label>
        <h5>{{ this.crid }}</h5>
      </div>
      <div class="mr-5">
        <cool-label>Demand Partner</cool-label>
        <h5 v-if="details.demand_partner">{{ details.demand_partner }}</h5>
        <h5 v-else><text-skeleton>ayyyyyyyy</text-skeleton></h5>
      </div>
      <div class="d-flex align-items-center ml-auto">
        <b-btn variant="primary" :to="runReportTo" class="mr-3">Run Report</b-btn>
        <b-btn variant="light">Block </b-btn>
      </div>
    </div>
    <b-row no-gutters>
      <b-col class="side-card">
        <b-card no-body bg-variant="light" class="border-top-0 border-bottom-0 border-left-0 rounded-0 h-100">
          <div class="mx-3 mt-4">
            <cool-label>Sample Preview</cool-label>
            <b-card no-body class="p-1" variant="lighter">
              <sample-ad-preview :iurl="iUrlOrEmptyString"></sample-ad-preview>
            </b-card>
            <div class="d-flex flex-wrap">
              <div class="mr-3">
                <cool-label>Bids</cool-label>
                <h5 v-if="details.bids">{{ details.bids | round }}</h5>
                <h5 v-else><text-skeleton bg-class="bg-border">ayyy</text-skeleton></h5>
              </div>
              <div class="mr-3">
                <cool-label>Impressions</cool-label>
                <h5 v-if="details.clears">{{ details.clears | round }}</h5>
                <h5 v-else><text-skeleton bg-class="bg-border">ayyy</text-skeleton></h5>
              </div>
              <div class="mr-3">
                <cool-label>{{ this.moneyStat | prettyStatName }}</cool-label>
                <h5 v-if="details[this.moneyStat]">${{ details[this.moneyStat] | round }}</h5>
                <h5 v-else><text-skeleton bg-class="bg-border">ayyy</text-skeleton></h5>
              </div>
            </div>
          </div>
          <!-- finish later
          <hr class="hr-border">
          <div class="mx-3">
            <cool-label>TMT Status</cool-label>
            <b-card>TODO BABEY</b-card>
            <p class="small text-muted">Under the right conditions, the quality rating de bello gallico</p>
          </div>
          <hr class="hr-border">
          <div class="mx-3 mb-4">
            <cool-label>Source Code</cool-label>
            <b-textarea readonly class="rounded code-textarea bg-white" :rows="6" :value="sourceCode">
            </b-textarea>
          </div>
          -->
        </b-card>
      </b-col>
      <b-col>
        <div class="m-4">
          <cool-label class="text-medium">Date:</cool-label>
          <cool-label>{{ startDate }} - {{ endDate }}</cool-label>
          <b-row no-gutters>
            <b-col md="6" lg="4" v-for="preview in previews" :key="preview.id">
              <b-card
                no-body
                class="m-lg-3 m-sm-2 m-1"
                footer-class="p-2"
                bg-variant="lighter"
                footer-bg-variant="white">
                <div class="m-3">
                  <live-ad-preview style="min-height: 15em;" :adm="preview.bid_adm">
                  </live-ad-preview>
                </div>
                <div slot="footer" class="d-flex flex-wrap">
                  <div class="mr-2 mw-100">
                    <cool-label class="m-0">Bid ID:</cool-label>
                    <strong class="small">{{ preview.bid_id }}</strong>
                  </div>
                  <div class="mr-2 mw-100">
                    <cool-label class="m-0">Auction ID:</cool-label>
                    <strong class="small">{{ preview.id }}</strong>
                  </div>
                  <div class="mr-2 mw-100">
                    <cool-label class="m-0">Bid Price:</cool-label>
                    <strong class="small">${{ preview.bid_price }}</strong>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<style scoped>
.instance-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.side-card {
  width: 200px;
  flex: 0 1 auto;
}
hr.hr-border {
  border-color: var(--border);
}
textarea.code-textarea {
  font-size: 12px;
}
strong.small {
  font-weight: bolder;
}
</style>

<script>
import LiveAdPreview from '@/components/preview/LiveAdPreview'
import { ReportsApi } from '@/reports/api'
import { getPrettyStatName, getDefaultPriceField } from '@/reports/components/ReportUtils'
import SampleAdPreview from '@/components/preview/SampleAdPreview'
import moment from 'moment'
import TextSkeleton from '@/components/TextSkeleton'

export default {
  props: {
    publisherId: { type: String, required: false },
    partnerId: { type: String, required: true },
    cid: { type: String, required: true },
    crid: { type: String, required: true }
  },
  data () {
    return {
      details: {},
      previews: [],
      moneyStat: ''
    }
  },
  created () {
    this.moneyStat = getDefaultPriceField()
    this.getDetails()
    this.getPreviews()
  },
  computed: {
    type () {
      if (this.$route.name === 'PublisherAdDetails') {
        return 'publisher'
      } else if (this.$route.name === 'DemandAdDetails') {
        return 'demand'
      } else if (this.$route.name === 'AdminAdDetails') {
        return 'admin'
      } else {
        return 'undefined'
      }
    },
    iUrlOrEmptyString () {
      return this.details.iurl || ''
    },
    sourceCode () {
      if (this.previews.length > 0) {
        for (let preview of this.previews) {
          if ('adm' in preview) {
            return preview.adm
          }
        }
      } else {
        return ''
      }
    },
    detailsQuery () {
      let query = {
        dateAsMillis: true,
        fields: ['demand_partner', 'demand_partner_id', 'bid_iurl'],
        filters: [
          { field: 'bid_crid', operator: 'EQUAL', value: this.crid },
          { field: 'bid_cid', operator: 'EQUAL', value: this.cid },
          { field: 'demand_partner_id', operator: 'EQUAL', value: Number(this.partnerId) },
        ],
        stats: ['bids', 'clears'],
        timezone: 'UTC',
        limit: 1
      }
      query.stats.push(this.moneyStat)
      return query
    },
    previewQuery () {
      let startTime = this.startMillis
      let endTime = this.endMillis
      return {
        dateAsMillis: true,
        startTime: startTime,
        endTime: endTime,
        fields: ['bid_id', 'id', 'bid_price', 'bid_adm'],
        filters: [
          { field: 'demand_partner_id', operator: 'EQUAL', value: Number(this.partnerId) },
          { field: 'bid_cid', operator: 'EQUAL', value: this.cid },
          { field: 'bid_crid', operator: 'EQUAL', value: this.crid },
          { field: 'bid_adm', operator: 'NOT_NULL', value: null }
        ],
        stats: [],
        timezone: 'UTC',
        limit: 9
      }
    },
    startMillis () {
      return this.$route.query.start || moment().subtract(1, 'days').startOf('day').valueOf()
    },
    endMillis () {
      return this.$route.query.end || moment().endOf('day').valueOf()
    },
    startDate () {
      return moment(Number(this.startMillis)).format('MMMM Do')
    },
    endDate () {
      return moment(Number(this.endMillis)).format('MMMM Do')
    },
    //redirects to explorer page
    runReportTo () {
      let name
      let params
      if (this.type === 'publisher') {
        name = 'PublisherExplorer'
        params = { publisherId: this.publisherId }
      } else if (this.type === 'demand') {
        name = 'DemandExplorer'
        params = { partnerId: this.partnerId }
      } else if (this.type === 'admin') {
        name = 'AdminExplorer'
        params = {}
      }
      let query = {
        filters: [
          { field: 'demand_partner_id', operator: 'EQUAL', value: Number(this.partnerId) },
          { field: 'bid_cid', operator: 'EQUAL', value: this.cid },
          { field: 'bid_crid', operator: 'EQUAL', value: this.crid }
        ],
        stats: ['bid_price'],
        fields: ['id'],
        startTime: this.startMillis,
        endTime: this.endMillis
      }

      return { name: name, params: params, query: { settings: JSON.stringify(query) }}
    },
  },
  methods: {
    getDetails () {
      return ReportsApi.bqreport(this.detailsQuery, this).then((data) => {
        this.details = data.results[0]
      }, (e) => {
        console.error(e)
      })
    },
    getPreviews () {
      return ReportsApi.bqreport(this.previewQuery, this).then((data) => {
        this.previews = data.results
      }, (e) => {
        console.error(e)
      })
    }
  },
  filters: {
    round (num) {
      return Math.round(Number(num))
    },
    prettyStatName (name) {
      return getPrettyStatName(name)
    }
  },
  components: {
    LiveAdPreview,
    SampleAdPreview,
    TextSkeleton
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/pages/AdDetails.vue